import { createClient } from '@supabase/supabase-js';
import { leesModusFetch } from './os/leesModus';

// Vervang deze waarden met jouw Supabase project URL en anon key
// Vind je op: https://app.supabase.com -> jouw project -> Settings -> API
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://jouw-project.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'jouw-anon-key';

// leesModusFetch laat alles door, behalve schrijfverzoeken als de ingelogde gebruiker alleen mag raadplegen.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { global: { fetch: leesModusFetch } });

// ─── DATABASE HELPERS ────────────────────────────────────────────────────────

// Services (Validatie pipeline)
export const db = {
  // Services
  async getServices() {
    const { data, error } = await supabase.from('services').select('*').order('created_at', { ascending: false });
    if (error) console.error('getServices:', error);
    return data || [];
  },
  async upsertService(service) {
    const { data, error } = await supabase.from('services').upsert(service).select();
    if (error) console.error('upsertService:', error);
    return data?.[0];
  },

  // Pipeline
  async getPipeline() {
    const { data, error } = await supabase.from('pipeline').select('*').order('created_at', { ascending: false });
    if (error) console.error('getPipeline:', error);
    return data || [];
  },
  async upsertPipeline(item) {
    const { data, error } = await supabase.from('pipeline').upsert(item).select();
    if (error) console.error('upsertPipeline:', error);
    return data?.[0];
  },

  // Leads
  async getLeads() {
    const { data, error } = await supabase.from('leads').select('*').order('created_at', { ascending: false });
    if (error) console.error('getLeads:', error);
    return data || [];
  },
  async upsertLead(lead) {
    const { data, error } = await supabase.from('leads').upsert(lead).select();
    if (error) console.error('upsertLead:', error);
    return data?.[0];
  },

  // Taken
  async getTasks() {
    const { data, error } = await supabase.from('tasks').select('*').order('due', { ascending: true });
    if (error) console.error('getTasks:', error);
    return data || [];
  },
  async upsertTask(task) {
    const { data, error } = await supabase.from('tasks').upsert(task).select();
    if (error) console.error('upsertTask:', error);
    return data?.[0];
  },
  async deleteTask(id) {
    const { error } = await supabase.from('tasks').delete().eq('id', id);
    if (error) console.error('deleteTask:', error);
  },

  // Agenda events
  async getEvents() {
    const { data, error } = await supabase.from('events').select('*').order('date', { ascending: true });
    if (error) console.error('getEvents:', error);
    return data || [];
  },
  async upsertEvent(event) {
    const { data, error } = await supabase.from('events').upsert(event).select();
    if (error) console.error('upsertEvent:', error);
    return data?.[0];
  },
  async deleteEvent(id) {
    const { error } = await supabase.from('events').delete().eq('id', id);
    if (error) console.error('deleteEvent:', error);
  },

  // Meetings
  async getMeetings() {
    const { data, error } = await supabase.from('meetings').select('*').order('date', { ascending: false });
    if (error) console.error('getMeetings:', error);
    return data || [];
  },
  async upsertMeeting(meeting) {
    const { data, error } = await supabase.from('meetings').upsert(meeting).select();
    if (error) console.error('upsertMeeting:', error);
    return data?.[0];
  },

  // Documenten
  async getDocuments() {
    const { data, error } = await supabase.from('documents').select('*').order('created_at', { ascending: false });
    if (error) console.error('getDocuments:', error);
    return data || [];
  },
  async upsertDocument(doc) {
    const { data, error } = await supabase.from('documents').upsert(doc).select();
    if (error) console.error('upsertDocument:', error);
    return data?.[0];
  },
  async deleteDocument(id) {
    const { error } = await supabase.from('documents').delete().eq('id', id);
    if (error) console.error('deleteDocument:', error);
  },
};

// ─── REALTIME SUBSCRIPTIONS ──────────────────────────────────────────────────
// Gebruik dit om live updates te ontvangen wanneer Tristan iets wijzigt
export function subscribeToTable(table, callback) {
  return supabase
    .channel(table + '_changes')
    .on('postgres_changes', { event: '*', schema: 'public', table }, callback)
    .subscribe();
}

// ─── SUPABASE AUTH (Productie versie) ────────────────────────────────────────
// Gebruik dit in productie in plaats van de lokale auth in App.jsx
// Instructies: https://supabase.com/docs/guides/auth

export const auth = {
  async signIn(email, password) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
    return data.user;
  },

  async signUp(email, password) {
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) throw error;
    return data.user;
  },

  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  async getUser() {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  },

  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange((event, session) => {
      callback(session?.user || null);
    });
  }
};

// Supabase Auth setup instructies:
// 1. Ga naar Supabase -> Authentication -> Users
// 2. Klik "Invite user" -> voer furgel@dif3r3nt.nl in
// 3. Klik "Invite user" -> voer tristan@dif3r3nt.nl in
// 4. Beide ontvangen een uitnodigingsmail om een wachtwoord in te stellen
// 5. Vervang de useAuth() hook in App.jsx met auth.signIn() / auth.signOut()
